(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wanna-cart-design"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.WannaCleanCart) return;
    let active = null;
    const readWishlist = () => {
      const cookie = document.cookie.split('; ').find(value => value.startsWith('wishlist='));
      const entries = cookie ? JSON.parse(cookie.slice(9)) : [];
      if (!Array.isArray(entries)) throw new Error('Invalid wishlist');
      return entries;
    };
    const syncHearts = () => {
      let entries;
      try { entries = readWishlist(); } catch { return; }
      document.querySelectorAll('.wanna-cart-save').forEach(button => {
        const row = button.closest('[data-cart-key]');
        const saved = entries.some(entry => String(entry.var) === row?.dataset.cartItemVariantId);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', saved ? button.dataset.savedLabel : button.dataset.saveLabel);
      });
    };
    const saveWishlist = (row, toggle = false) => {
      let entries = readWishlist();
      const variant = row.dataset.cartItemVariantId;
      const wasSaved = entries.some(entry => String(entry.var) === variant);
      if (!wasSaved || toggle) {
        if (wasSaved) entries = entries.filter(entry => String(entry.var) !== variant);
        else entries.push({ id: row.dataset.productId, handle: row.dataset.productUrl, var: variant });
        const value = JSON.stringify(entries);
        if (new TextEncoder().encode(`wishlist=${value}`).length > 3800) throw new Error('Wishlist full');
        document.cookie = `wishlist=${value}; max-age=2592000; path=/; SameSite=Lax`;
        if (readWishlist().some(entry => String(entry.var) === variant) !== !wasSaved) throw new Error('Wishlist not saved');
      }
      if (typeof wishlistArray !== 'undefined') wishlistArray = entries;
      document.querySelectorAll('.wishlist_link').forEach(link => {
        link.classList.toggle('active', entries.length > 0);
        const bubble = link.querySelector('.wishlist-bubble');
        if (bubble) { bubble.classList.toggle('hidden', !entries.length); bubble.textContent = String(entries.length); }
      });
      document.querySelectorAll('wishlist-btn').forEach(button => {
        button.classList.toggle('active', entries.some(entry => String(entry.var) === button.dataset.var));
      });
      syncHearts();
    };
    const confirmRemoval = (owner, row, event, name, variantId) => {
      const input = row.querySelector('.quantity__input');
      if (input) input.value = input.defaultValue;
      input?.closest('quantity-input')?.validateQtyRules?.();
      if (active || row.dataset.canRemove === 'false') return Promise.resolve(false);
      const template = document.querySelector('[data-wanna-cart-dialog]');
      if (!template || !window.HTMLDialogElement?.prototype.showModal) return Promise.resolve(false);
      const dialog = template.content.firstElementChild.cloneNode(true);
      const originalFocus = document.activeElement;
      const image = row.querySelector('.cart-item__image');
      const preview = dialog.querySelector('[data-cart-dialog-image]');
      if (image) { preview.src = image.currentSrc || image.src; preview.alt = image.alt; }
      else preview.hidden = true;
      dialog.querySelector('[data-cart-dialog-name]').textContent = row.querySelector('.cart-item__name')?.textContent.trim() || '';
      dialog.querySelector('[data-cart-dialog-options]').textContent = Array.from(row.querySelectorAll('.wanna-cart-option dd'), el => el.textContent.trim()).join(' / ');
      dialog.querySelector('[data-cart-dialog-qr]').hidden = row.dataset.qrProduct !== 'true';
      let busy = false;
      const bodyWasLocked = document.body.classList.contains('overflow-hidden');
      const key = row.dataset.cartKey;
      return new Promise(resolve => {
        active = dialog;
        document.body.append(dialog);
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        document.body.classList.add('overflow-hidden');
        dialog.showModal();
        dialog.querySelector('h2').focus({ preventScroll: true });
        const close = result => {
          dialog.close();
          dialog.remove();
          active = null;
          if (!bodyWasLocked) document.body.classList.remove('overflow-hidden');
          const drawer = document.querySelector('cart-drawer.active');
          const fallback = drawer?.querySelector('.drawer__close') || document.querySelector('cart-items .title');
          const focus = originalFocus?.isConnected ? originalFocus : fallback;
          if (drawer && typeof trapFocus === 'function') trapFocus(drawer, focus || drawer);
          else focus?.focus({ preventScroll: true });
          resolve(result);
        };
        const setBusy = value => {
          busy = value;
          dialog.querySelectorAll('button').forEach(button => { button.disabled = value; });
          dialog.setAttribute('aria-busy', String(value));
        };
        const commit = async save => {
          if (busy) return;
          setBusy(true);
          const error = dialog.querySelector('[data-cart-dialog-error]');
          error.textContent = '';
          if (save) {
            try { saveWishlist(row); }
            catch { error.textContent = dialog.dataset.wishlistError; setBusy(false); return; }
          }
          const currentOwner = owner.isConnected ? owner : document.querySelector(owner.localName);
          const currentRow = Array.from(currentOwner?.querySelectorAll('[data-cart-key]') || []).find(item => item.dataset.cartKey === key);
          if (!currentRow) { close(false); return; }
          const line = currentRow.querySelector('.quantity__input')?.dataset.index;
          try {
            const result = await currentOwner.updateQuantity(line, 0, event || { currentTarget: null }, name, variantId, key);
            if (result === false) throw new Error('Removal not confirmed');
            close(true);
          } catch {
            error.textContent = dialog.dataset.removeError;
            setBusy(false);
            if (typeof removeTrapFocus === 'function') removeTrapFocus();
            dialog.querySelector('h2').focus({ preventScroll: true });
          }
        };
        dialog.querySelector('[data-cart-cancel]').addEventListener('click', () => { if (!busy) close(false); });
        dialog.querySelector('[data-cart-remove]').addEventListener('click', () => commit(false));
        dialog.querySelector('[data-cart-save-remove]').addEventListener('click', () => commit(true));
        dialog.addEventListener('cancel', e => { e.preventDefault(); if (!busy) close(false); });
        dialog.addEventListener('click', e => {
          const rect = dialog.getBoundingClientRect();
          if (!busy && e.target === dialog && (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom)) close(false);
        });
        dialog.addEventListener('keyup', e => e.stopPropagation());
      });
    };
    document.addEventListener('click', event => {
      const button = event.target.closest('.wanna-cart-save');
      if (!button) return;
      event.preventDefault();
      const row = button.closest('[data-cart-key]');
      try { saveWishlist(row, true); }
      catch {
        const error = row.querySelector('.cart-item__error-text');
        const template = document.querySelector('[data-wanna-cart-dialog]');
        if (error) error.textContent = template?.content.firstElementChild.dataset.wishlistError || '';
      }
    });
    window.WannaCleanCart = { confirmRemoval };
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; syncHearts(); });
    }).observe(document.body, { childList: true, subtree: true });
    syncHearts();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wanna-mobile-product-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wanna-product-bar')) {
  customElements.define('wanna-product-bar', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      if (!this.product || this.closest('quick-add-modal') || !this.closest('#MainContent')) return;
      this.button = this.querySelector('.wanna-product-bar__button');
      this.buttonLabel = this.querySelector('.wanna-product-bar__button-label');
      this.buttonPrice = this.querySelector('.wanna-product-bar__button-price');
      this.titleElement = this.querySelector('.wanna-product-bar__title');
      this.error = this.querySelector('.wanna-product-bar__error');
      this.sheet = this.querySelector('.wanna-size-sheet');
      this.options = this.querySelector('.wanna-size-sheet__options');
      this.sheetError = this.querySelector('.wanna-size-sheet__error');
      this.mobile = matchMedia('(max-width: 749px)');
      this.events = new AbortController();
      const eventOptions = {signal:this.events.signal};
      document.addEventListener('keydown', event => {
        if (event.key === 'Tab' || (this.contains(event.target) && ['Enter',' ','Escape','ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(event.key))) {
          this.setAttribute('data-keyboard-focus', '');
        }
      }, {...eventOptions,capture:true});
      const pointerFocus = () => this.removeAttribute('data-keyboard-focus');
      document.addEventListener('pointerdown', pointerFocus, {...eventOptions,capture:true,passive:true});
      document.addEventListener('touchstart', pointerFocus, {...eventOptions,capture:true,passive:true});
      this.sheet.addEventListener('click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, {...eventOptions,capture:true});
      this.sheet.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { this.resetDrag(); return; }
        this.startDrag(event.touches[0].clientX, event.touches[0].clientY);
      }, {...eventOptions,passive:true});
      this.sheet.addEventListener('touchmove', event => {
        if (event.touches.length !== 1) { this.resetDrag(); return; }
        if (this.moveDrag(event.touches[0].clientX, event.touches[0].clientY)) event.preventDefault();
      }, {...eventOptions,passive:false});
      this.sheet.addEventListener('touchend', () => this.finishDrag(), eventOptions);
      this.sheet.addEventListener('touchcancel', () => this.resetDrag(), eventOptions);
      this.sheet.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button === 0 && !this.outside(event)) this.startDrag(event.clientX,event.clientY);
      }, eventOptions);
      this.sheet.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse') return;
        if (this.moveDrag(event.clientX,event.clientY)) {
          this.sheet.setPointerCapture(event.pointerId);
          event.preventDefault();
        }
      }, eventOptions);
      this.sheet.addEventListener('pointerup', event => { if (event.pointerType === 'mouse') this.finishDrag(); }, eventOptions);
      this.sheet.addEventListener('pointercancel', event => { if (event.pointerType === 'mouse') this.resetDrag(); }, eventOptions);
      this.sheet.querySelector('.wanna-size-sheet__close').addEventListener('click', () => this.closeSheet(), eventOptions);
      this.sheet.addEventListener('cancel', event => { event.preventDefault(); this.closeSheet(); }, eventOptions);
      this.sheet.addEventListener('close', () => { this.resetSheet(); this.sync?.(); }, eventOptions);
      this.sheet.addEventListener('pointerdown', event => { this.backdropDown = event.target === this.sheet && this.outside(event); }, eventOptions);
      this.sheet.addEventListener('click', event => {
        if (event.target === this.sheet && this.backdropDown && this.outside(event)) this.closeSheet();
        const choice = event.target.closest('[data-size-input-id]');
        if (choice && !choice.disabled) this.selectSize(choice);
      }, eventOptions);
      this.mobile.addEventListener('change', () => { if (!this.mobile.matches) this.closeSheet(); this.sync?.(); }, eventOptions);
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) !== this.dataset.sectionId) return;
          this.sync();
          if (!this.pending) return;
          const expected = this.pending;
          if (!data.variant || !expected.values.every((value, index) => value === data.variant.options[index])) return;
          clearTimeout(this.selectionTimer);
          this.continueTimer = setTimeout(() => {
            if (this.pending !== expected || !this.sheet.open || !this.mobile.matches) return;
            this.sync();
            const formVariant = this.original?.form?.querySelector('[name="id"]')?.value;
            if (!data.variant.available || String(data.variant.id) !== formVariant || this.original.disabled || this.original.getAttribute('aria-disabled') === 'true') {
              this.selectionFailed();
              return;
            }
            this.closeSheet();
            this.original.click();
          }, 0);
        });
      }
      this.sync = () => {
        const original = this.product.querySelector('[id="ProductSubmitButton-' + this.dataset.sectionId + '"]');
        if (!original) { this.hidden = true; this.product.removeAttribute('data-wanna-product-bar'); return; }
        this.original = original;
        this.hidden = false;
        this.product.setAttribute('data-wanna-product-bar', '');
        this.syncGuidePosition();
        const disabled = original.disabled || original.getAttribute('aria-disabled') === 'true' || original.classList.contains('loading');
        const inputs = this.sizeInputs();
        this.hasSizes = inputs.length > 0 && typeof subscribe === 'function';
        this.product.toggleAttribute('data-wanna-size-sheet', this.hasSizes);
        inputs[0]?.closest('.product-form__input')?.setAttribute('data-wanna-inline-size', '');
        const availableSizes = inputs.some(input => !input.disabled && !input.classList.contains('disabled'));
        this.button.disabled = this.hasSizes ? (!availableSizes || !!this.pending || original.classList.contains('loading') || original.getAttribute('aria-disabled') === 'true') : disabled;
        if (this.sheet.open && !this.pending) this.renderSizes();
        this.button.setAttribute('aria-busy', String(original.classList.contains('loading')));
        const nativeLabel = original.querySelector('span:not(.loading__spinner)')?.textContent.trim() || original.textContent.trim();
        const label = this.hasSizes ? (this.sheet.open ? this.dataset.selectLabel : this.dataset.addLabel) : nativeLabel;
        if (this.buttonLabel.textContent !== label) this.buttonLabel.textContent = label;
        const popup = this.hasSizes ? 'dialog' : original.getAttribute('aria-haspopup');
        if (popup) this.button.setAttribute('aria-haspopup', popup);
        else this.button.removeAttribute('aria-haspopup');
        const heading = this.product.querySelector('.product__title h1');
        if (heading && this.titleElement.textContent !== heading.textContent) this.titleElement.textContent = heading.textContent;
        const source = this.product.querySelector('[id="price-' + this.dataset.sectionId + '"] .price');
        const html = source?.outerHTML || '';
        if (html !== this.lastPrice) {
          this.lastPrice = html;
          const onSale = source?.classList.contains('price--on-sale');
          const currentPrice = source?.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
          this.buttonPrice.textContent = currentPrice?.textContent.trim() || '';

        }
        const errorWrapper = this.product.querySelector('.product-form__error-message-wrapper');
        const message = errorWrapper && !errorWrapper.hidden ? errorWrapper.querySelector('.product-form__error-message')?.textContent.trim() : '';
        if (this.error.textContent !== (message || '')) this.error.textContent = message || '';
        this.error.hidden = !message;
      };
      this.onClick = () => {
        this.sync();
        if (!this.original || this.button.disabled) return;
        if (this.hasSizes && this.mobile.matches) this.openSheet();
        else this.original.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target) && record.target !== this.product)) this.sync();
      });
      this.observer.observe(this.product, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','hidden']});
      this.resize = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--wanna-product-bar-height', this.getBoundingClientRect().height + 'px');
      });
      this.resize.observe(this);
      this.sync();
    }
    startDrag(x,y) {
      if (!this.sheet.open || this.sheet.scrollTop > 0) return;
      this.drag = {x,y,start:performance.now(),distance:0,active:false};
    }
    moveDrag(x,y) {
      if (!this.drag) return false;
      const dx = x - this.drag.x;
      const dy = y - this.drag.y;
      if (!this.drag.active) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return false;
        if (dy <= 0 || dy < Math.abs(dx) * 1.2) { this.resetDrag(); return false; }
        this.drag.active = true;
        this.sheet.setAttribute('data-dragging','');
      }
      this.drag.distance = Math.max(0,dy);
      this.suppressClickUntil = performance.now() + 600;
      this.sheet.style.setProperty('--wanna-sheet-drag',this.drag.distance + 'px');
      return true;
    }
    finishDrag() {
      if (!this.drag) return;
      const {active,distance,start} = this.drag;
      const velocity = distance / Math.max(1,performance.now() - start);
      this.resetDrag();
      if (active && (distance >= 50 || (distance >= 24 && velocity > .45))) this.closeSheet();
    }
    resetDrag() {
      this.drag = null;
      this.sheet?.removeAttribute('data-dragging');
      this.sheet?.style.removeProperty('--wanna-sheet-drag');
    }
    sizeInputs() {
      if (!Number(this.dataset.sizePosition)) return [];
      const prefix = this.dataset.sectionId + '-' + this.dataset.sizePosition + '-';
      return Array.from(this.product.querySelector('variant-selects')?.querySelectorAll('input[type="radio"]') || []).filter(input => input.id.startsWith(prefix));
    }
    renderSizes() {
      const inputs = this.sizeInputs();
      const signature = JSON.stringify(inputs.map(input => [input.id, input.value, input.disabled, input.classList.contains('disabled')]));
      if (signature === this.sizeSignature) return;
      this.sizeSignature = signature;
      this.options.replaceChildren(...inputs.map(input => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = input.value;
        button.dataset.sizeInputId = input.id;
        button.disabled = input.disabled || input.classList.contains('disabled');
        button.toggleAttribute('data-unavailable', button.disabled);
        return button;
      }));
    }
    syncGuidePosition() {
      const picker = this.product.querySelector('variant-selects');
      const guide = this.product.querySelector('.product__info-container > .wanna-product-size-guide');
      if (!guide || !picker) return;
      if (this.mobile.matches) {
        if (this.guidePlaceholder?.isConnected) {
          this.guidePlaceholder.after(guide);
          this.guidePlaceholder.remove();
          this.guidePlaceholder = null;
          guide.removeAttribute('data-wanna-desktop-guide');
        }
        return;
      }
      if (!this.guidePlaceholder?.isConnected) {
        this.guidePlaceholder = document.createComment('wanna-size-guide-position');
        guide.before(this.guidePlaceholder);
      }
      this.desktopGuide = guide;
      let guideAnchor = picker;
      while (guideAnchor.nextElementSibling?.matches('variant-selects') && guideAnchor.nextElementSibling.style.display === 'none') {
        guideAnchor = guideAnchor.nextElementSibling;
      }
      if (guideAnchor.nextElementSibling !== guide) guideAnchor.after(guide);
      guide.setAttribute('data-wanna-desktop-guide', '');
    }
    openSheet() {
      if (this.sheet.open) return;
      this.suppressClickUntil = 0;
      this.resetDrag();
      this.sizeSignature = null;
      this.renderSizes();
      this.sheetError.hidden = true;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.sheet.showModal();
      this.sync();
      this.options.querySelector('button:not(:disabled)')?.focus({preventScroll:true});
    }
    outside(event) {
      const rect = this.sheet.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    resetSheet() {
      this.resetDrag();
      clearTimeout(this.selectionTimer);
      clearTimeout(this.continueTimer);
      this.pending = null;
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }
    closeSheet() {
      this.resetSheet();
      if (this.sheet?.open) { this.sheet.close(); this.button?.focus({preventScroll:true}); }
      this.sync?.();
    }
    selectSize(choice) {
      if (this.pending) return;
      const input = this.sizeInputs().find(input => input.id === choice.dataset.sizeInputId);
      if (!input || input.disabled || input.classList.contains('disabled')) return;
      this.sheetError.hidden = true;
      input.checked = true;
      const groups = this.product.querySelector('variant-selects').querySelectorAll('.product-form__input');
      const values = Array.from(groups, group => group.querySelector('input:checked, select')?.value);
      this.pending = {values};
      this.options.querySelectorAll('button').forEach(button => { button.disabled = true; });
      choice.setAttribute('aria-busy', 'true');
      this.selectionTimer = setTimeout(() => this.selectionFailed(), 15000);
      input.dispatchEvent(new Event('change', {bubbles:true}));
      this.sync();
    }
    selectionFailed() {
      this.resetSheet();
      if (this.sheet.open) {
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      this.sizeSignature = null;
      this.renderSizes();
      this.sheetError.textContent = this.dataset.sizeError;
      this.sheetError.hidden = false;
      this.sync();
    }
    disconnectedCallback() {
      if (this.guidePlaceholder?.isConnected && this.desktopGuide?.isConnected) {
        this.guidePlaceholder.after(this.desktopGuide);
        this.desktopGuide.removeAttribute('data-wanna-desktop-guide');
      }
      this.guidePlaceholder?.remove();
      this.guidePlaceholder = null;
      this.resetSheet();
      this.sheet?.close();
      this.events?.abort();
      this.unsubscribe?.();
      this.observer?.disconnect();
      this.resize?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      this.product?.removeAttribute('data-wanna-product-bar');
      this.product?.removeAttribute('data-wanna-size-sheet');
      document.documentElement.style.removeProperty('--wanna-product-bar-height');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wanna-model-photo-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wanna-model-photo-badge')) {
    customElements.define('wanna-model-photo-badge', class extends HTMLElement {
      connectedCallback() {
        this.disconnect();
        const template = this.querySelector('[data-model-photo-entries]');
        try { this.entries = JSON.parse(template.content.textContent); }
        catch { this.hidden = true; return; }
        this.root = this.closest(this.dataset.context === 'card' ? '.card__inner' : '.product-media-container');
        if (!this.root) { this.hidden = true; return; }
        this.heightText = this.querySelector('[data-model-photo-height]');
        this.sizeText = this.querySelector('[data-model-photo-size]');
        this.events = new AbortController();
        const options = {signal: this.events.signal, passive: true, capture: true};
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        for (const event of ['scroll', 'load', 'transitionend', 'pointerenter', 'pointerleave']) {
          this.root.addEventListener(event, this.schedule, options);
        }
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.root, {subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'class', 'style']});
        this.resize = new ResizeObserver(this.schedule);
        this.resize.observe(this.root);
        this.sync();
      }
      disconnectedCallback() { this.disconnect(); }
      disconnect() {
        this.events?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      key(src) {
        try { return decodeURIComponent(new URL(src, location.href).pathname.split('/').pop()); }
        catch { return ''; }
      }
      sync() {
        if (!this.isConnected) return;
        let photo;
        if (this.dataset.context === 'card') {
          if (this.root.querySelector('.wanna-card-gallery-stage')) { this.hidden = true; return; }
          const track = this.root.querySelector('.wanna-card-native-gallery');
          if (track?.children.length) {
            const width = track.firstElementChild.getBoundingClientRect().width;
            if (!width) { this.hidden = true; return; }
            const index = Math.max(0, Math.min(track.children.length - 1, Math.round(track.scrollLeft / width)));
            photo = track.children[index].querySelector('img');
          } else {
            photo = this.root.querySelector('.wanna-card-hover-preview.is-visible img');
            if (!photo) {
              const images = [...this.root.querySelectorAll('.card__media .media > img')];
              photo = images.filter(image => {
                const style = getComputedStyle(image);
                return style.visibility !== 'hidden' && Number(style.opacity) > .5 && style.display !== 'none';
              }).pop();
            }
          }
        } else {
          photo = this.root.querySelector('.product__media img');
        }
        const key = this.key(photo?.getAttribute('src') || '');
        const entry = key && this.entries.find(item => this.key(item.src) === key);
        this.hidden = !entry;
        if (entry) {
          if (this.heightText.textContent !== entry.height) this.heightText.textContent = entry.height;
          if (this.sizeText.textContent !== entry.size) this.sizeText.textContent = entry.size;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wanna-product-card-resources"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wanna-collection-card')) {
  class WannaCollectionCard extends HTMLElement {
    static cartQueue = Promise.resolve();
    static qrLoader = null;

    static async getQrCustomizer(url) {
      if (window.WannaQRCustomizer) return window.WannaQRCustomizer;
      if (!this.qrLoader) {
        this.qrLoader = (async () => {
          const response = await fetch(url, {headers: {'Accept': 'text/html'}});
          if (!response.ok) throw new Error('QR popup unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const component = page.querySelector('[data-wanna-qr-component]');
          if (!component || typeof HTMLUpdateUtility === 'undefined') throw new Error('QR popup unavailable');
          const host = document.createElement('div');
          host.hidden = true;
          host.setAttribute('data-wanna-qr-loader', '');
          document.body.append(host);
          HTMLUpdateUtility.setInnerHTML(host, component.outerHTML);
          if (!window.WannaQRCustomizer) {
            host.remove();
            throw new Error('QR popup unavailable');
          }
          return window.WannaQRCustomizer;
        })().catch(error => {
          this.qrLoader = null;
          throw error;
        });
      }
      return this.qrLoader;
    }

    connectedCallback() {
      if (!this.hasAttribute('data-wanna-collection')) return;
      this.setupTimer = setTimeout(() => this.setup(), 0);
    }

    disconnectedCallback() {
      clearTimeout(this.setupTimer);
      this.clearHoverPreview();
      this.events?.abort();
      this.galleryObserver?.disconnect();
      this.removeNativeGallery();
      this.galleryRevision = (this.galleryRevision || 0) + 1;
      this.galleryStage?.remove();
      this.galleryGesture = null;
      this.sheet?.close();
      this.sheet?.remove();
      this.sheet = null;
    }

    setup() {
      const template = this.querySelector('[data-wanna-card-config]');
      if (!template) return;
      if (!this.config) {
        try { this.config = JSON.parse(template.content.textContent); } catch { return; }
        this.defaultVariant = this.config.variants.find(v => v.id === this.config.defaultId);
        if (!this.defaultVariant) return;
        this.variant = this.defaultVariant;
        this.colorIndex = this.config.colorIndex;
        this.sizeIndex = this.config.optionNames.findIndex(name => ['size', 'größe', 'groesse', 'taille', 'talla'].includes(name.toLowerCase()));
        const simpleOptions = this.config.optionNames.every((name, index) => index === this.colorIndex || index === this.sizeIndex || (name === 'Title' && this.config.variants.length === 1));
        const simpleQuantities = this.config.variants.every(v => v.min === 1 && v.step === 1 && (v.max == null || v.max >= 1));
        this.direct = this.config.direct && simpleOptions && simpleQuantities;
        this.image = this.querySelector('.card__media .media > img');
        this.originalImage = this.image ? Object.fromEntries(['src', 'srcset', 'sizes', 'alt'].map(name => [name, this.image.getAttribute(name)])) : null;
        this.swatches = [...this.querySelectorAll('.product-swatches [data-wanna-color]')];
        this.links = [...this.querySelectorAll('.link-after, .card__heading a')];
        this.originalLinks = this.links.map(link => link.getAttribute('href'));
        this.openers = [...this.querySelectorAll('.quick-add [data-product-url]')];
        this.originalOpenerUrls = this.openers.map(button => button.dataset.productUrl);
        this.price = this.querySelector('.card__information .price');
        this.originalPrice = this.price?.innerHTML;
        this.originalPriceClass = this.price?.className;
        this.strip = this.querySelector('[data-wanna-size-strip]');
        this.sizes = this.querySelector('[data-wanna-size-options]');
        this.error = this.querySelector('[data-wanna-size-error]');
        this.viewCart = this.querySelector('[data-wanna-view-cart]');
        this.swatches.forEach(swatch => {
          if (!swatch.dataset.wannaImage && swatch.dataset.wannaColor !== this.defaultColor()) return;
          swatch.setAttribute('role', 'button');
          swatch.removeAttribute('aria-current');
          swatch.setAttribute('aria-pressed', String(swatch.dataset.wannaColor === this.defaultColor()));
        });
        if (this.direct && this.strip) {
          this.strip.hidden = false;
          this.renderSizes();
          this.querySelectorAll('.quick-add__submit').forEach(button => {
            button.removeAttribute('aria-haspopup');
            button.setAttribute('aria-expanded', 'false');
          });
        }
        if (this.hasAttribute('data-wanna-wishlist') && this.direct) {
          const available = this.config.variants.some(variant => variant.available && variant.options.every((value, index) => index === this.sizeIndex || value === this.variant.options[index]));
          this.querySelectorAll('.quick-add__submit').forEach(button => {
            button.disabled = !available;
            const label = button.querySelector('span');
            if (label) label.textContent = available ? this.config.addLabel : this.config.soldOutLabel;
          });
          this.updatePrice(this.variant);
        }
        this.querySelector('wishlist-btn')?.syncVariant?.();
        this.setAttribute('data-wanna-ready', '');
      }
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      // History restores focus and even :hover. Wait for fresh interaction.
      const resetHistoryUI = () => {
        this.setAttribute('data-wanna-returned', '');
        this.removeAttribute('data-wanna-keyboard');
        this.desktopHovered = false;
        this.clearHoverPreview();
        if (this.contains(document.activeElement)) document.activeElement.blur();
        if (this.busy || this.uncertain) return; // Never reset an unresolved cart request.
        this.setOpen(false);
        this.sheet?.close();
      };
      window.addEventListener('pagehide', resetHistoryUI, options);
      window.addEventListener('pageshow', event => { if (event.persisted) resetHistoryUI(); }, options);
      if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') resetHistoryUI();
      document.addEventListener('keydown', event => {
        if (event.key !== 'Tab' && !(this.contains(event.target) && ['Enter', ' ', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key))) return;
        this.setAttribute('data-wanna-keyboard', '');
        this.removeAttribute('data-wanna-returned');
      }, {...options, capture: true});
      document.addEventListener('pointerdown', () => this.removeAttribute('data-wanna-keyboard'), {...options, capture: true, passive: true});
      this.addEventListener('pointermove', event => {
        if (event.pointerType === 'touch' || !this.hasAttribute('data-wanna-returned')) return;
        this.removeAttribute('data-wanna-returned');
        this.desktopHovered = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
      }, options);
      this.setupGallery(options);
      this.addEventListener('pointerover', event => {
        if (event.pointerType === 'touch' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const swatch = event.target.closest('[data-wanna-color]');
        if (swatch) this.selectSwatch(swatch);
      }, options);
      this.addEventListener('focusin', event => {
        const swatch = event.target.closest('[data-wanna-color]');
        if (swatch) this.selectSwatch(swatch);
      }, options);
      this.addEventListener('click', event => this.onClick(event), {...options, capture: true});
      this.addEventListener('keydown', event => {
        const swatch = event.target.closest('[data-wanna-color][role="button"]');
        if (swatch && event.key === ' ') { event.preventDefault(); swatch.click(); }
        if (event.key === 'Escape' && this.hasAttribute('data-wanna-open')) {
          this.setOpen(false);
          this.querySelector('.quick-add__submit')?.focus();
        }
      }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch' || !matchMedia('(hover: hover) and (pointer: fine)').matches || this.galleryGesture || this.galleryMoving || this.busy || this.uncertain || this.sheet?.open || (this.hasAttribute('data-wanna-keyboard') && this.contains(document.activeElement))) return;
        this.resetPreview();
      }, options);
      this.addEventListener('focusout', event => {
        if (matchMedia('(hover: hover) and (pointer: fine)').matches && !this.galleryGesture && !this.galleryMoving && !this.contains(event.relatedTarget) && !this.sheet?.contains(event.relatedTarget) && !this.matches(':hover') && !this.busy && !this.uncertain) this.resetPreview();
      }, options);
    }

    setupGallery(options) {
      if (!this.config.gallery || !this.image) return;
      this.galleryInner = this.querySelector('.card__inner');
      if (!this.galleryInner || !this.config.gallery.images.length) return;
      if (!this.galleryControls) {
        this.galleryControls = document.createElement('div');
        this.galleryControls.className = 'wanna-card-gallery-controls';
        for (const direction of [-1, 1]) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'wanna-card-gallery-arrow';
          button.dataset.galleryDirection = direction;
          button.setAttribute('aria-label', direction < 0 ? this.config.gallery.previous : this.config.gallery.next);
          button.innerHTML = '<svg viewBox="0 0 12 20" width="8" height="12" aria-hidden="true"><path d="' + (direction < 0 ? 'M9 3 2 10l7 7' : 'm3 3 7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
          this.galleryControls.append(button);
        }
        this.galleryInner.append(this.galleryControls);
      }
      this.galleryTouchMedia = matchMedia('(max-width: 749px), (hover: none), (pointer: coarse)');
      this.galleryTouchMedia.addEventListener('change', () => { this.clearHoverPreview(); this.syncNativeGallery(); }, options);
      this.syncGallery();
      this.galleryObserver?.disconnect();
      if ('IntersectionObserver' in window) {
        this.galleryObserver = new IntersectionObserver(entries => {
          this.galleryNearby = entries[0].isIntersecting;
          if (this.galleryNearby) this.preloadGalleryNeighbours();
        }, {rootMargin: '150px'});
        this.galleryObserver.observe(this.galleryInner);
      }
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch' || this.hasAttribute('data-wanna-returned') || !matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches) return;
        this.desktopHovered = true;
        this.updateHoverPreview(event);
      }, options);
      this.addEventListener('pointermove', event => this.updateHoverPreview(event), options);
      this.addEventListener('pointerleave', () => {
        this.desktopHovered = false;
        this.hoverPreviewPaused = false;
        this.clearHoverPreview();
      }, options);
      this.galleryInner.addEventListener('pointerdown', event => {
        if (this.galleryNative || !event.isPrimary || event.button !== 0 || this.galleryItems.length < 2 || event.target.closest('button, wishlist-btn, .wanna-size-strip') || this.busy || this.uncertain || this.galleryMoving || this.galleryGesture) return;
        this.hoverPreviewPaused = true;
        this.clearHoverPreview();
        this.preloadGalleryNeighbours();
        this.galleryGesture = {id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, horizontal: false, cancelled: false, offset: 0};
      }, options);
      this.galleryInner.addEventListener('pointermove', event => {
        const gesture = this.galleryGesture;
        if (!gesture || gesture.id !== event.pointerId || gesture.type !== event.pointerType || gesture.cancelled) return;
        const x = event.clientX - gesture.x, y = event.clientY - gesture.y;
        if (!gesture.horizontal) {
          if (Math.abs(y) > 10 && Math.abs(y) >= Math.abs(x)) { gesture.cancelled = true; return; }
          if (Math.abs(x) < 12 || Math.abs(x) < Math.abs(y) * 1.3) return;
          gesture.horizontal = true;
          this.beginGalleryDrag(gesture);
          this.galleryInner.setPointerCapture(event.pointerId);
        }
        gesture.offset = Math.max(-gesture.width, Math.min(gesture.width, x));
        this.positionGalleryDrag(gesture);
        event.preventDefault();
      }, options);
      this.galleryInner.addEventListener('pointerup', event => {
        const gesture = this.galleryGesture;
        if (!gesture || gesture.id !== event.pointerId || gesture.type !== event.pointerType) return;
        this.galleryGesture = null;
        if (!gesture.horizontal) return;
        this.gallerySuppressClickUntil = performance.now() + 500;
        if (this.galleryInner.hasPointerCapture(event.pointerId)) this.galleryInner.releasePointerCapture(event.pointerId);
        gesture.offset = Math.max(-gesture.width, Math.min(gesture.width, event.clientX - gesture.x));
        this.finishGalleryDrag(gesture, Math.abs(gesture.offset) >= Math.max(30, gesture.width * .18));
      }, options);
      const cancelDrag = event => {
        const gesture = this.galleryGesture;
        if (!gesture || gesture.id !== event.pointerId || gesture.type !== event.pointerType) return;
        this.galleryGesture = null;
        if (gesture.horizontal) {
          this.gallerySuppressClickUntil = performance.now() + 500;
          this.finishGalleryDrag(gesture, false);
        }
      };
      this.galleryInner.addEventListener('pointercancel', cancelDrag, options);
      this.galleryInner.addEventListener('lostpointercapture', event => {
        // Touch capture transfers from the product link to this gallery on drag.
        if (event.target === this.galleryInner) cancelDrag(event);
      }, options);
      this.galleryInner.addEventListener('dragstart', event => event.preventDefault(), options);
    }

    removeNativeGallery() {
      clearTimeout(this.galleryLoopTimer);
      this.galleryNativeTouching = false;
      this.galleryNativeEvents?.abort();
      this.galleryNativeResize?.disconnect();
      this.galleryNative?.remove();
      this.galleryNative = null;
      this.galleryNativeRecenter = null;
      this.galleryNativePrime = null;
      this.removeAttribute('data-wanna-native-gallery');
    }

    syncNativeGallery() {
      this.removeNativeGallery();
      if (!this.galleryTouchMedia?.matches || this.galleryItems?.length < 2) return;
      // Let iOS own the horizontal pan. The displayed slides stay in the DOM:
      // pointercancel is normal during native scrolling and must never reset them.
      const track = document.createElement('div');
      track.className = 'wanna-card-native-gallery';
      const fit = getComputedStyle(this.image);
      const count = this.galleryItems.length;
      const slides = [...this.galleryItems, ...this.galleryItems, ...this.galleryItems];
      slides.forEach((item, index) => {
        const link = document.createElement('a');
        link.href = this.links[0]?.href || this.variant.url;
        link.tabIndex = -1;
        if (index < count || index >= count * 2) link.setAttribute('aria-hidden', 'true');
        const photo = new Image();
        photo.loading = 'lazy';
        photo.decoding = 'async';
        photo.draggable = false;
        photo.sizes = this.image.sizes;
        photo.srcset = item.srcset;
        photo.src = item.src;
        photo.alt = item.alt || this.config.productTitle;
        photo.style.objectFit = fit.objectFit;
        photo.style.objectPosition = fit.objectPosition;
        link.append(photo);
        track.append(link);
      });
      this.galleryNative = track;
      this.setAttribute('data-wanna-native-gallery', '');
      this.galleryInner.append(track);
      let width = Math.ceil(track.getBoundingClientRect().width);
      track.style.setProperty('--wanna-native-slide-width', `${width}px`);
      const offsetFor = slot => track.children[slot].offsetLeft - track.children[0].offsetLeft;
      track.scrollLeft = offsetFor(count + this.galleryIndex);
      let previousScroll = track.scrollLeft;
      this.galleryNativeEvents = new AbortController();
      const options = {signal: this.galleryNativeEvents.signal, passive: true};
      const primeCopies = () => {
        // Prepare the current image and its neighbours in every cycle, only
        // when the card is near the viewport or being used.
        for (const direction of [-1, 0, 1]) {
          const index = (this.galleryIndex + direction + count) % count;
          for (let cycle = 0; cycle < 3; cycle++) {
            track.children[cycle * count + index].querySelector('img').loading = 'eager';
          }
        }
      };
      this.galleryNativePrime = primeCopies;
      const settleLoop = () => {
        clearTimeout(this.galleryLoopTimer);
        if (this.galleryNative !== track || this.galleryNativeTouching || !width) return;
        const slot = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
        // Use the actual snap position, including fractional card-width rounding.
        if (Math.abs(track.scrollLeft - offsetFor(slot)) > 2.5) return;
        if (slot >= count && slot < count * 2) return;
        const target = count + slot % count;
        const visiblePhoto = track.children[slot].querySelector('img');
        const otherPhoto = track.children[target].querySelector('img');
        // Carry the already-visible image to the identical middle-cycle slide.
        // Do not wait for a separate lazy-loaded copy before reopening the loop.
        visiblePhoto.replaceWith(otherPhoto);
        track.children[target].append(visiblePhoto);
        previousScroll = offsetFor(target);
        track.scrollTo({left: previousScroll, behavior: 'instant'});
        previousScroll = track.scrollLeft;
        this.galleryIndex = target - count;
      };
      this.galleryNativeRecenter = settleLoop;
      const scheduleLoop = () => {
        clearTimeout(this.galleryLoopTimer);
        this.galleryLoopTimer = setTimeout(settleLoop, 160);
      };
      track.addEventListener('touchstart', event => {
        if (event.touches.length === 1) {
          // A new swipe may arrive before scrollend/the quiet timer. Normalize
          // an already-snapped outer cycle before this new gesture starts.
          this.galleryNativeTouching = false;
          settleLoop();
        }
        this.galleryNativeTouching = true;
        primeCopies();
        clearTimeout(this.galleryLoopTimer);
      }, options);
      const endTouch = event => {
        this.galleryNativeTouching = event.touches.length > 0;
        if (!this.galleryNativeTouching) scheduleLoop();
      };
      track.addEventListener('touchend', endTouch, options);
      track.addEventListener('touchcancel', endTouch, options);
      track.addEventListener('scrollend', settleLoop, options);
      track.addEventListener('load', scheduleLoop, {...options, capture: true});
      track.addEventListener('scroll', () => {
        if (!width) return;
        const position = Math.max(0, track.scrollLeft);
        if (Math.abs(position - previousScroll) > 1) {
          this.gallerySuppressClickUntil = performance.now() + 350;
          this.setAttribute('data-wanna-gallery-used', '');
        }
        previousScroll = position;
        this.galleryIndex = ((Math.round(position / width) % count) + count) % count;
        if (this.galleryNearby || this.galleryNativeTouching) primeCopies();
        scheduleLoop();
      }, options);
      if (this.galleryNearby) primeCopies();
      if ('ResizeObserver' in window) {
        this.galleryNativeResize = new ResizeObserver(() => {
          const nextWidth = Math.ceil(track.getBoundingClientRect().width);
          if (nextWidth === width) return;
          width = nextWidth;
          track.style.setProperty('--wanna-native-slide-width', `${width}px`);
          clearTimeout(this.galleryLoopTimer);
          previousScroll = offsetFor(count + this.galleryIndex);
          track.scrollLeft = previousScroll;
          previousScroll = track.scrollLeft;
        });
        this.galleryNativeResize.observe(track);
      }
    }

    galleryPhoto(item) {
      this.galleryPhotoCache ||= new Map();
      const key = item.src + '|' + this.image.sizes;
      if (!this.galleryPhotoCache.has(key)) {
        const image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'low';
        image.sizes = this.image.sizes;
        image.srcset = item.srcset;
        image.src = item.src;
        image.alt = item.alt || this.config.productTitle;
        this.galleryPhotoCache.set(key, image);
      }
      return this.galleryPhotoCache.get(key);
    }

    preloadGalleryNeighbours() {
      this.galleryNativePrime?.();
      if (this.galleryItems?.length < 2) return;
      for (const direction of [-1, 1]) {
        const index = (this.galleryIndex + direction + this.galleryItems.length) % this.galleryItems.length;
        this.galleryPhoto(this.galleryItems[index]);
      }
    }

    beginGalleryDrag(gesture) {
      gesture.width = Math.max(1, this.image.parentElement.getBoundingClientRect().width);
      gesture.revision = this.galleryRevision;
      const stage = document.createElement('div');
      stage.className = 'wanna-card-gallery-stage';
      stage.setAttribute('aria-hidden', 'true');
      gesture.photos = [-1, 0, 1].map(direction => {
        const index = (this.galleryIndex + direction + this.galleryItems.length) % this.galleryItems.length;
        const photo = direction === 0 ? this.image.cloneNode() : this.galleryPhoto(this.galleryItems[index]).cloneNode();
        photo.removeAttribute('id');
        photo.loading = 'eager';
        photo.draggable = false;
        stage.append(photo);
        return photo;
      });
      gesture.stage = stage;
      this.positionGalleryDrag(gesture);
      this.image.parentElement.append(stage);
      this.galleryStage = stage;
      this.galleryMoving = true;
      this.image.style.visibility = 'hidden';
    }

    positionGalleryDrag(gesture) {
      gesture.photos.forEach((photo, index) => {
        photo.style.transform = `translate3d(${(index - 1) * gesture.width + gesture.offset}px, 0, 0)`;
      });
    }

    async finishGalleryDrag(gesture, commit) {
      const direction = gesture.offset < 0 ? 1 : -1;
      const nextIndex = (this.galleryIndex + direction + this.galleryItems.length) % this.galleryItems.length;
      const item = this.galleryItems[nextIndex];
      if (commit) {
        try { await this.galleryPhoto(item).decode(); } catch { commit = false; }
      }
      if (gesture.revision !== this.galleryRevision || !this.isConnected) { gesture.stage.remove(); return; }
      if (commit) this.setAttribute('data-wanna-gallery-used', '');
      const endOffset = commit ? -direction * gesture.width : 0;
      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
      const animations = gesture.photos.map((photo, index) => {
        const base = (index - 1) * gesture.width;
        return photo.animate([
          {transform: `translate3d(${base + gesture.offset}px, 0, 0)`},
          {transform: `translate3d(${base + endOffset}px, 0, 0)`}
        ], {duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards'});
      });
      await Promise.allSettled(animations.map(animation => animation.finished));
      if (gesture.revision !== this.galleryRevision || !this.isConnected) { gesture.stage.remove(); return; }
      if (commit) await this.settleGalleryImage(item, nextIndex, gesture.revision);
      if (gesture.revision !== this.galleryRevision || !this.isConnected) { gesture.stage.remove(); return; }
      this.image.style.removeProperty('visibility');
      gesture.stage.remove();
      this.galleryStage = null;
      this.galleryMoving = false;
      this.preloadGalleryNeighbours();
    }

    async settleGalleryImage(item, index, revision) {
      // Keep the finished slide covering the main image until its own decode completes.
      // A decoded preload does not guarantee the replacement <img> has painted in Safari.
      const previous = {src: this.image.getAttribute('src'), srcset: this.image.getAttribute('srcset'), alt: this.image.alt};
      this.image.srcset = item.srcset;
      this.image.src = item.src;
      this.image.alt = item.alt || this.config.productTitle;
      try {
        await this.image.decode();
      } catch {
        if (revision !== this.galleryRevision || !this.isConnected) return;
        Object.entries(previous).forEach(([name, value]) => value == null ? this.image.removeAttribute(name) : this.image.setAttribute(name, value));
        return;
      }
      if (revision !== this.galleryRevision || !this.isConnected) return;
      this.galleryIndex = index;
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    }

    clearHoverPreview() {
      this.hoverPreviewRequested = false;
      this.hoverPreviewRevision = (this.hoverPreviewRevision || 0) + 1;
      this.hoverPreview?.classList.remove('is-visible');
    }

    updateHoverPreview(event) {
      if (event.pointerType === 'touch' || !this.desktopHovered) return;
      const rect = this.galleryInner.getBoundingClientRect();
      const stripHeight = this.strip && !this.strip.hidden ? this.strip.offsetHeight : 0;
      const overImage = event.clientX >= rect.left && event.clientX < rect.right && event.clientY >= rect.top && event.clientY < rect.bottom - stripHeight && !event.target.closest('button, wishlist-btn, .wanna-size-strip');
      if (!overImage) {
        this.hoverPreviewPaused = false;
        this.clearHoverPreview();
      } else if (!event.buttons && !this.hoverPreviewPaused && !this.hoverPreviewRequested) {
        this.showHoverPreview();
      }
    }

    async showHoverPreview() {
      if (!this.desktopHovered || this.galleryItems?.length < 2 || this.galleryIndex !== 0) return;
      this.clearHoverPreview();
      this.hoverPreviewRequested = true;
      const revision = this.hoverPreviewRevision;
      // Preview only over the image, above the size row; no hover delay.
      if (this.busy || this.uncertain || this.galleryMoving || this.galleryGesture || !this.desktopHovered) return;
      const item = this.galleryItems[1];
      const image = new Image();
      image.srcset = item.srcset;
      image.sizes = this.image.sizes;
      image.src = item.src;
      image.alt = '';
      try { await image.decode(); } catch { return; }
      if (revision !== this.hoverPreviewRevision || !this.isConnected || !this.desktopHovered || this.busy || this.galleryMoving) return;
      if (!this.hoverPreview) {
        this.hoverPreview = document.createElement('div');
        this.hoverPreview.className = 'wanna-card-hover-preview';
        this.hoverPreview.setAttribute('aria-hidden', 'true');
        this.image.parentElement.append(this.hoverPreview);
      }
      this.hoverPreview.replaceChildren(image);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (revision === this.hoverPreviewRevision && this.desktopHovered) this.hoverPreview.classList.add('is-visible');
      }));
    }

    syncGallery() {
      this.clearHoverPreview();
      if (!this.galleryControls) return;
      this.galleryRevision = (this.galleryRevision || 0) + 1;
      this.galleryStage?.remove();
      this.galleryStage = null;
      this.galleryGesture = null;
      this.galleryMoving = false;
      this.image.style.removeProperty('visibility');
      const color = this.variant.options[this.colorIndex];
      const images = this.config.gallery.images;
      const cleanURL = src => { try { return new URL(src, location.href).pathname; } catch { return src; } };
      const first = images.find(item => cleanURL(item.src) === cleanURL(this.image.src));
      this.galleryItems = images.filter(item => this.colorIndex < 0 || !item.color || item.color === color || item === first);
      if (first) this.galleryItems = [first, ...this.galleryItems.filter(item => item !== first)];
      this.galleryIndex = 0;
      this.galleryControls.hidden = this.galleryItems.length < 2;
      this.toggleAttribute('data-wanna-gallery', this.galleryItems.length > 1);
      this.syncNativeGallery();
      if (this.galleryNearby) this.preloadGalleryNeighbours();
    }

    async moveGallery(direction) {
      if (this.galleryNative) {
        if (this.busy || this.uncertain) return;
        const track = this.galleryNative;
        const width = track.firstElementChild.getBoundingClientRect().width;
        if (!width) return;
        this.galleryNativeRecenter?.();
        const slot = Math.round(track.scrollLeft / width);
        const target = Math.max(0, Math.min(track.children.length - 1, slot + direction));
        const left = track.children[target].offsetLeft - track.children[0].offsetLeft;
        track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        return;
      }
      if (this.galleryMoving || this.galleryItems?.length < 2 || this.busy || this.uncertain) return;
      this.hoverPreviewPaused = true;
      this.clearHoverPreview();
      this.galleryMoving = true;
      const revision = this.galleryRevision;
      const nextIndex = (this.galleryIndex + direction + this.galleryItems.length) % this.galleryItems.length;
      const item = this.galleryItems[nextIndex];
      const incoming = new Image();
      incoming.srcset = item.srcset;
      incoming.sizes = this.image.sizes;
      incoming.src = item.src;
      incoming.alt = item.alt || this.config.productTitle;
      try { await incoming.decode(); } catch { if (revision === this.galleryRevision) this.galleryMoving = false; return; }
      if (revision !== this.galleryRevision || !this.isConnected) return;
      const stage = document.createElement('div');
      stage.className = 'wanna-card-gallery-stage';
      stage.setAttribute('aria-hidden', 'true');
      const outgoing = this.image.cloneNode();
      outgoing.removeAttribute('id');
      stage.append(outgoing, incoming);
      this.image.parentElement.append(stage);
      this.galleryStage = stage;
      this.image.style.visibility = 'hidden';
      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240;
      const timing = {duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards'};
      const animations = [outgoing.animate([{transform: 'translateX(0)'}, {transform: `translateX(${-direction * 100}%)`}], timing), incoming.animate([{transform: `translateX(${direction * 100}%)`}, {transform: 'translateX(0)'}], timing)];
      await Promise.allSettled(animations.map(animation => animation.finished));
      if (revision !== this.galleryRevision || !this.isConnected) { stage.remove(); return; }
      await this.settleGalleryImage(item, nextIndex, revision);
      if (revision !== this.galleryRevision || !this.isConnected) { stage.remove(); return; }
      this.image.style.removeProperty('visibility');
      stage.remove();
      this.galleryStage = null;
      this.galleryMoving = false;
      this.preloadGalleryNeighbours();
    }

    defaultColor() { return this.defaultVariant.options[this.colorIndex]; }

    selectSwatch(swatch) {
      if (this.busy || this.uncertain) return false;
      const color = swatch.dataset.wannaColor;
      if (color !== this.defaultColor() && !swatch.dataset.wannaImage) return false;
      const variants = this.config.variants.filter(v => v.options[this.colorIndex] === color);
      const variant = variants.find(v => v.available) || variants[0];
      if (!variant) return false;
      if (this.variant.options[this.colorIndex] === color) return true;
      this.variant = variant;
      if (this.image) {
        if (color === this.defaultColor()) this.restoreImage();
        else {
          this.image.removeAttribute('srcset');
          this.image.src = swatch.dataset.wannaImage;
          this.image.srcset = swatch.dataset.wannaSrcset || '';
          this.image.alt = `${this.config.productTitle} — ${color}`;
        }
      }
      this.links.forEach(link => link.href = variant.url);
      this.openers.forEach(button => button.dataset.productUrl = variant.url);
      this.swatches.forEach(link => {
        const selected = link.dataset.wannaColor === color;
        link.classList.toggle('product-swatch-link--selected', selected);
        if (link.getAttribute('role') === 'button') link.setAttribute('aria-pressed', String(selected));
      });
      this.querySelector('wishlist-btn')?.syncVariant?.();
      this.updatePrice(variant);
      this.syncGallery();
      if (this.direct) this.renderSizes();
      return true;
    }

    restoreImage() {
      if (!this.image) return;
      Object.entries(this.originalImage).forEach(([name, value]) => value == null ? this.image.removeAttribute(name) : this.image.setAttribute(name, value));
    }

    updatePrice(variant) {
      if (!this.price) return;
      this.price.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(node => node.textContent = variant.money);
      this.price.querySelectorAll('.price__sale .price-item--regular').forEach(node => node.textContent = variant.compareMoney);
      this.price.classList.toggle('price--on-sale', variant.compare > variant.price);
      this.price.classList.toggle('price--sold-out', !variant.available);
    }

    resetPreview() {
      this.variant = this.defaultVariant;
      this.querySelector('wishlist-btn')?.syncVariant?.();
      this.restoreImage();
      this.syncGallery();
      this.links.forEach((link, i) => link.setAttribute('href', this.originalLinks[i]));
      this.openers.forEach((button, i) => button.dataset.productUrl = this.originalOpenerUrls[i]);
      this.swatches.forEach(swatch => {
        const selected = swatch.dataset.wannaColor === this.defaultColor();
        swatch.classList.toggle('product-swatch-link--selected', selected);
        if (swatch.getAttribute('role') === 'button') swatch.setAttribute('aria-pressed', String(selected));
      });
      if (this.price) { this.price.innerHTML = this.originalPrice; this.price.className = this.originalPriceClass; }
      if (this.direct) this.renderSizes();
      this.setOpen(false);
    }

    renderSizes() {
      if (!this.sizes) return;
      const matching = this.config.variants.filter(v => v.options.every((value, index) => index === this.sizeIndex || value === this.variant.options[index]));
      const sizeValues = this.sizeIndex < 0 ? [null] : [...new Set(this.config.variants.map(v => v.options[this.sizeIndex]))];
      this.sizes.replaceChildren(...sizeValues.map(size => {
        const variant = this.sizeIndex < 0 ? matching[0] : matching.find(v => v.options[this.sizeIndex] === size);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wanna-size-button';
        button.textContent = size || this.config.addLabel;
        button.disabled = !variant?.available;
        button.dataset.wannaVariant = variant?.id || '';
        button.setAttribute('aria-label', [variant?.available ? this.config.addLabel : this.config.soldOutLabel, this.config.productTitle, ...this.variant.options.filter((_, i) => i !== this.sizeIndex), size].filter(Boolean).join(' — '));
        return button;
      }));
      if (this.error) this.error.hidden = true;
    }

    setOpen(open) {
      this.toggleAttribute('data-wanna-open', open);
      if (this.direct) this.querySelectorAll('.quick-add__submit').forEach(button => button.setAttribute('aria-expanded', String(open)));
    }

    useSheet() { return matchMedia('(max-width: 749px), (hover: none)').matches; }

    dismissSheet() {
      if (!this.sheet?.open || this.sheetClosing) return;
      this.sheetClosing = true;
      const from = getComputedStyle(this.sheet).transform;
      this.sheet.getAnimations().forEach(animation => animation.cancel());
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.sheet.close();
        return;
      }
      const animation = this.sheet.animate([{transform: from}, {transform: 'translateY(100%)'}], {duration: 180, easing: 'ease-in', fill: 'forwards'});
      animation.finished.then(() => { if (this.sheet?.open) this.sheet.close(); }).catch(() => {});
    }

    bindSheetDrag(handle) {
      let drag = null;
      const reset = () => {
        const from = this.sheet.style.transform || 'translateY(0)';
        this.sheet.style.removeProperty('transform');
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) this.sheet.animate([{transform: from}, {transform: 'translateY(0)'}], {duration: 160, easing: 'ease-out'});
      };
      handle.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || this.sheetClosing) return;
        this.sheet.getAnimations().forEach(animation => animation.cancel());
        drag = {id: event.pointerId, y: event.clientY, x: event.clientX, time: performance.now(), distance: 0};
        handle.setPointerCapture(event.pointerId);
      });
      handle.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        drag.distance = Math.max(0, event.clientY - drag.y);
        if (drag.distance > 4) this.sheet.style.transform = `translateY(${drag.distance}px)`;
      });
      const finish = (event, cancelled = false) => {
        if (!drag || event.pointerId !== drag.id) return;
        const gesture = drag;
        drag = null;
        if (handle.hasPointerCapture(event.pointerId)) handle.releasePointerCapture(event.pointerId);
        const moved = Math.abs(event.clientY - gesture.y) > 4 || Math.abs(event.clientX - gesture.x) > 4;
        if (moved || cancelled) this.sheetSuppressClickUntil = performance.now() + 400;
        const velocity = gesture.distance / Math.max(1, performance.now() - gesture.time);
        if (!cancelled && (gesture.distance >= 60 || (gesture.distance >= 24 && velocity > .5))) this.dismissSheet();
        else reset();
      };
      handle.addEventListener('pointerup', event => finish(event));
      handle.addEventListener('pointercancel', event => finish(event, true));
      handle.addEventListener('lostpointercapture', event => { if (drag) finish(event, true); });
    }

    openSheet(opener) {
      if (!this.sheet) {
        this.sheet = document.createElement('dialog');
        this.sheet.className = 'wanna-card-size-sheet';
        this.sheet.tabIndex = -1;
        this.sheet.setAttribute('aria-label', this.config.productTitle);
        const handle = document.createElement('button');
        handle.type = 'button';
        handle.className = 'wanna-sheet-handle';
        handle.setAttribute('aria-label', this.config.closeLabel);
        handle.addEventListener('click', event => {
          if (event.detail === 0 || performance.now() >= (this.sheetSuppressClickUntil || 0)) this.dismissSheet();
        });
        this.bindSheetDrag(handle);
        this.sheetDetails = document.createElement('a');
        this.sheetDetails.className = 'wanna-sheet-details';
        this.sheetDetails.textContent = this.config.detailsLabel;
        this.sheetFooter = document.createElement('div');
        this.sheetFooter.className = 'wanna-sheet-footer';
        this.sheetFooter.append(this.sheetDetails);
        const guide = this.querySelector('template[data-wanna-card-guide]');
        if (guide) this.sheetFooter.append(guide.content.cloneNode(true));
        this.sheet.append(handle, this.sheetFooter);
        this.sheet.addEventListener('click', event => {
          if (event.target === this.sheet) {
            const bounds = this.sheet.getBoundingClientRect();
            if (event.clientY < bounds.top || event.clientY > bounds.bottom || event.clientX < bounds.left || event.clientX > bounds.right) this.dismissSheet();
          }
          this.onClick(event);
        });
        this.sheet.addEventListener('cancel', event => {
          event.preventDefault();
          this.dismissSheet();
        });
        this.sheet.addEventListener('close', () => {
          this.sheet.getAnimations().forEach(animation => animation.cancel());
          this.sheet.style.removeProperty('transform');
          this.sheetClosing = false;
          this.querySelector('.card__inner')?.append(this.strip);
          this.setOpen(false);
          if (!this.bodyWasLocked && !document.querySelector('cart-drawer.active')) document.body.classList.remove('overflow-hidden');
        });
        document.body.append(this.sheet);
      }
      this.sheetOpener = opener;
      this.sheetDetails.href = this.variant.url;
      this.sheet.insertBefore(this.strip, this.sheetFooter);
      this.bodyWasLocked = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      this.sheet.showModal();
      if (this.sheet.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.sheet.animate([{transform: 'translateY(100%)'}, {transform: 'translateY(0)'}], {duration: 180, easing: 'ease-out'});
      }
      this.sheet.focus({preventScroll: true});
    }

    onClick(event) {
      if (performance.now() < (this.gallerySuppressClickUntil || 0) && event.target.closest('.card__inner') && !event.target.closest('button, wishlist-btn')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const galleryArrow = event.target.closest('[data-gallery-direction]');
      if (galleryArrow) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.moveGallery(Number(galleryArrow.dataset.galleryDirection));
        return;
      }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      const swatch = event.target.closest('[data-wanna-color][role="button"]');
      if (swatch) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.selectSwatch(swatch) && this.direct && !this.useSheet()) this.setOpen(true);
        return;
      }
      if (!this.direct) return;
      const opener = event.target.closest('.quick-add__submit');
      if (opener) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || this.uncertain || opener.disabled) return;
        const matching = this.config.variants.filter(variant => variant.options.every((value, index) => index === this.sizeIndex || value === this.variant.options[index]));
        if (matching.length === 1 && matching[0].available && !(this.hasAttribute('data-wanna-wishlist') && this.sizeIndex >= 0)) {
          this.sheetOpener = opener;
          this.queueVariant(matching[0], opener);
          return;
        }
        this.setOpen(true);
        if (this.useSheet()) { this.openSheet(opener); return; }
        this.sizes?.querySelector('button:not(:disabled)')?.focus({preventScroll: true});
        return;
      }
      const button = event.target.closest('[data-wanna-variant]');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.uncertain || button.disabled) return;
      const variant = this.config.variants.find(v => v.id === button.dataset.wannaVariant);
      if (!variant?.available) return;
      this.queueVariant(variant, button);
    }

    queueVariant(variant, button) {
      if (this.busy || this.uncertain || button.disabled || !variant?.available) return;
      this.busy = true;
      this.setAttribute('data-wanna-busy', '');
      this.setOpen(true);
      this.sizes.setAttribute('aria-busy', 'true');
      this.sizes.querySelectorAll('button').forEach(node => node.setAttribute('aria-disabled', 'true'));
      button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      if (this.config.qr) {
        this.startQr(variant, button);
        return;
      }
      WannaCollectionCard.cartQueue = WannaCollectionCard.cartQueue.catch(() => {}).then(() => this.addVariant(variant, button));
    }

    releaseBusy(button) {
      this.busy = false;
      this.removeAttribute('data-wanna-busy');
      this.sizes.removeAttribute('aria-busy');
      this.sizes.querySelectorAll('button').forEach(node => node.removeAttribute('aria-disabled'));
      button.removeAttribute('aria-busy');
    }

    async startQr(variant, button) {
      let adding = false;
      try {
        const customizer = await WannaCollectionCard.getQrCustomizer(variant.url);
        if (!this.isConnected) return;
        const trigger = this.sheet?.open ? this.sheetOpener : button;
        if (this.sheet?.open) {
          await new Promise(resolve => {
            this.sheet.addEventListener('close', resolve, {once: true});
            this.sheet.close();
          });
        }
        const properties = await customizer.open({trigger});
        if (!properties) return;
        if (!properties.Platform || !properties.Identity) throw new Error('QR details missing');
        adding = true;
        WannaCollectionCard.cartQueue = WannaCollectionCard.cartQueue.catch(() => {}).then(() => this.addVariant(variant, button, properties, trigger));
      } catch {
        this.error.textContent = this.config.errorLabel;
        this.error.hidden = false;
        this.setOpen(true);
        if (this.useSheet() && !this.sheet?.open && this.isConnected) this.openSheet(this.sheetOpener || this.querySelector('.quick-add__submit'));
      } finally {
        if (!adding) this.releaseBusy(button);
      }
    }

    async addVariant(variant, button, properties, returnFocus) {
      const root = window.Shopify?.routes?.root || '/';
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.() || [];
      const body = {id: variant.id, quantity: 1};
      if (properties) body.properties = properties;
      if (sections.length) {
        body.sections = sections.map(section => section.id);
        body.sections_url = window.location.pathname;
      }
      let added = false;
      let rejected = false;
      try {
        if (this.config.qr && (!properties?.Platform || !properties?.Identity)) {
          rejected = true;
          throw new Error(this.config.errorLabel);
        }
        drawer?.setActiveElement(returnFocus || (this.sheet?.open ? this.sheetOpener : button));
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          rejected = response.status >= 400 && response.status < 500;
          throw new Error(typeof result.description === 'string' ? result.description : this.config.errorLabel);
        }
        added = true;
        if (this.sheet?.open) this.sheet.close();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source: 'wanna-collection-card', productVariantId: variant.id, cartData: result})).catch(() => {});
        }
        if (!drawer || !sections.every(section => typeof result.sections?.[section.id] === 'string')) {
          window.location.assign(`${root}cart`);
          return;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
      } catch (error) {
        if (added) { window.location.assign(`${root}cart`); return; }
        this.error.textContent = error.message || this.config.errorLabel;
        this.error.hidden = false;
        if (!rejected) {
          this.uncertain = true;
          this.viewCart.hidden = false;
          this.sizes.querySelectorAll('button').forEach(node => node.disabled = true);
        }
        if ((this.config.qr || button.matches('.quick-add__submit')) && this.useSheet() && !this.sheet?.open && this.isConnected) this.openSheet(this.sheetOpener || this.querySelector('.quick-add__submit'));
      } finally {
        this.releaseBusy(button);
      }
    }
  }
  customElements.define('wanna-collection-card', WannaCollectionCard);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wanna-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wanna-size-guide')) {
  customElements.define('wanna-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('.wanna-guide-link');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        this.openGuide(button);
      });
    }
    disconnectedCallback() { this.dialog?.close(); this.dialog?.remove(); this.dialog = null; }
    openGuide(opener) {
      if (this.dialog?.open) return;
      if (!this.dialog) {
        const template = this.querySelector('template');
        if (!template) return;
        this.dialog = document.createElement('dialog');
        this.dialog.className = 'wanna-guide-dialog';
        this.dialog.append(template.content.cloneNode(true));
        this.title = this.dialog.querySelector('.wanna-guide-title').textContent;
        this.dialog.setAttribute('aria-label', this.title);
        this.dialog.querySelector('.wanna-guide-close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          const button = event.target.closest('[data-guide-unit]');
          if (button) {
            const unit = button.dataset.guideUnit;
            this.dialog.querySelectorAll('[data-guide-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            this.dialog.querySelectorAll('[data-guide-cm]').forEach(cell => {
              cell.textContent = unit === 'inch' ? cell.dataset.guideInch : cell.dataset.guideCm;
            });
            this.dialog.querySelector('table').setAttribute('aria-label', `${this.title} — ${unit === 'inch' ? 'INCH' : 'CM'}`);
          }
          if (event.target === this.dialog && this.backdropDown && this.outside(event)) this.dialog.close();
        });
        this.dialog.addEventListener('pointerdown', event => { this.backdropDown = event.target === this.dialog && this.outside(event); });
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow;
          if (this.opener?.isConnected) this.opener.focus({preventScroll: true});
        });
        document.body.append(this.dialog);
      }
      this.opener = opener;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.dialog.querySelector('.wanna-guide-body').scrollTop = 0;
      this.dialog.querySelector('.wanna-guide-title').focus({preventScroll: true});
    }
    outside(event) {
      const r = this.dialog.getBoundingClientRect();
      return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
